import styled from 'styled-components';
import { DatePicker } from 'react-rainbow-components';
import Card from 'components/Card';
import { color } from 'theme';
import { DIVIDER, GREY_800 } from '../../../constants';

export const PageContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    height: auto;
`;

export const Header = styled.div`
    display: flex;
    align-self: stretch;
    justify-content: space-between;
    align-items: center;
    gap: 1rem;
`;

export const Title = styled.h1`
    margin: 0;
    font-size: 2.125rem;
    font-style: normal;
    font-weight: 900;
    line-height: 2.75rem;
`;

export const Actions = styled.div`
    display: flex;
    flex-shrink: 0;
    gap: 0.75rem;
    padding: 0.25rem;
    align-items: center;
`;

export const ReportDateField = styled.div`
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    gap: 0.75rem;
`;

export const ReportDateLabel = styled.label`
    margin: 0;
    font-size: 0.875rem;
    font-weight: 500;
    line-height: 1.5rem;
    color: ${color('text.main')};
    white-space: nowrap;
`;

/**
 * Match `components/Picklist` + Topics `StyledPicklist` (250px, pill, DIVIDER border).
 * Rainbow `DatePicker` is styled here directly so we are not overridden by `components/DatePicker`.
 */
export const StyledReportDatePicker = styled(DatePicker)`
    width: 250px;

    label {
        color: rgb(63, 73, 84);
        font-size: 0.875rem;
        line-height: 1.5;
        margin-bottom: 0.125rem;
        align-self: flex-start;
        box-sizing: border-box;
        margin-left: 1rem;
    }

    svg {
        color: ${GREY_800};
    }

    && input {
        border: 1px solid ${DIVIDER};
        border-radius: 6.25rem !important;
    }

    && input:focus,
    && input:active {
        border-radius: 6.25rem !important;
    }

    && input::placeholder {
        font-weight: 300 !important;
    }
`;

/** Same `Card` surface as `BusinessHealthWidget` / metric cards; theme tokens for icon + copy. */
export const EmptyStateCard = styled(Card)`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    min-height: 15rem;
    padding: 2.5rem 1.5rem;
    gap: 1rem;
`;

export const EmptyStateIconContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 4rem;
    height: 4rem;
    border-radius: 50%;
    flex-shrink: 0;
    background-color: ${color('brand.light')};
    color: ${color('brand.main')};

    > svg {
        width: 1.75rem;
        height: 1.75rem;
    }
`;

export const EmptyStateText = styled.p`
    margin: 0;
    max-width: 22rem;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5rem;
    text-align: center;
    color: ${color('text.label')};
`;
